import {forwardRef, useImperativeHandle, useState} from 'react'
import {Grid, Stack, Typography} from '@mui/material'
import File from 'src/components/ui/File'
import Attachment from 'src/entities/Attachment'

const ATTACHMENTS: Attachment[] = [
  {
    Id: 1,
    FormId: 0,
    CategoryId: 4,
    Description: 'אישור ניהול חשבון',
    DescriptionAfter: '',
    IsRequierd: true,
    UrlDownload: '',
    AllowFormat: '*',
    Order: 1,
    IsUploading: false,
    Month: -1,
    Year: 0
  },
  {
    Id: 2,
    FormId: 0,
    CategoryId: 6,
    Description: 'רשימת תלמידים',
    DescriptionAfter:
      'יש להשתמש בתבנית זו בלבד. זו תבנית שונה מתבנית קרן עולם התורה.',
    IsRequierd: true,
    UrlDownload: '/files/4 - רשימת תלמידים.xlsx',
    AllowFormat: '.xlsx,.xls',
    Order: 2,
    IsUploading: false,
    Month: -1,
    Year: 0
  }
]

export interface AttachmentsHandle {
  getAttachments: () => Attachment[]
  setUploading: (id: number, value: boolean) => void
}

const Attachments = forwardRef<AttachmentsHandle>((_, ref) => {
  const [attachments, setAttachments] = useState<Attachment[]>(ATTACHMENTS)

  const onUpload = (id: number, file: File) => {
    setAttachments(prev =>
      prev.map(a => (a.Id === id ? {...a, File: file} : a))
    )
  }

  const onDelete = (id: number) => {
    setAttachments(prev =>
      prev.map(a => (a.Id === id ? {...a, File: undefined} : a))
    )
  }

  useImperativeHandle(ref, () => ({
    getAttachments: () => attachments,
    setUploading: (id, value) =>
      setAttachments(prev =>
        prev.map(a => (a.Id === id ? {...a, IsUploading: value} : a))
      )
  }))

  return (
    <Stack spacing={2}>
      <Typography variant="h6">צירוף מסמכים:</Typography>
      <Grid container spacing={3} width={'100%'}>
        {attachments.map((a, index) => (
          <Grid item xs={3} key={index}>
            <File attachment={a} onUpload={onUpload} onDelete={onDelete} />
          </Grid>
        ))}
      </Grid>
    </Stack>
  )
})

export default Attachments
